{
  "fr": {
    "worksheet": {
      "autoSave": {
        "saved": "Modifications enregistrées",
        "saveFailed": "Les modifications n'ont pas pu être enregistrées",
        "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter pour enregistrer les modifications.",
        "draftRestoreFailed": "Le brouillon n'a pas pu être restauré"
      },
      "submitFailed": "Échec de la soumission. Veuillez réessayer.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Cours",
          "focus": "Définir le focus",
          "knowledge": "Savoir",
          "tasks": "Sélectionner des tâches",
          "topic": "Thème",
          "verify": "Vérifier la fiche d'exercices"
        },
        "buttons": {
          "createProposals": "Créer des suggestions",
          "createWorksheet": "Créer une fiche d'exercices",
          "creating": "Traitement en cours…",
          "generateLearningObjectives": "Laisser l'IA créer des objectifs d'apprentissage",
          "generateNewProposals": "Générer des suggestions alternatives",
          "generateTextBasis": "Laisser l'IA créer le texte de base",
          "regenerateLearningObjectives": "Créer de nouveaux objectifs d'apprentissage",
          "regenerateTextBasis": "Créer un nouveau texte de base",
          "retry": "Réessayer",
          "showTextBasis": "Afficher le texte de base sur la fiche d'exercices"
        },
        "course": {
          "grade": "Niveau scolaire",
          "language": "Langue",
          "school": "Type d'établissement",
          "subject": "Matière scolaire"
        },
        "descriptions": {
          "fillInTheBlank": "Complétez le texte à trous. Utilisez les termes suivants :<br/><strong>{hints}</strong>"
        },
        "errors": {
          "generationFailed": "La fiche d'exercices n'a pas pu être créée. Veuillez réessayer."
        },
        "headers": {
          "createTitle": "Créer une fiche d'exercices avec l'assistance IA",
          "kinds": {
            "fill_in_the_blank_text": "Sélectionner un texte à trous",
            "multiple_choice": "Sélectionner une question à choix multiple",
            "single_choice": "Sélectionner une question à choix unique",
            "text": "Suggestion pour une courte introduction au sujet",
            "text_assignment": "Sélectionner une tâche de texte",
            "text_assignment_1": "Sélectionner une tâche de texte (AFB I)",
            "text_assignment_2": "Sélectionner une tâche de texte (AFB II)",
            "text_assignment_3": "Sélectionner une tâche de texte (AFB III)"
          },
          "sampleSolution": "Solution modèle :",
          "title": "Créer une fiche d'exercices avec l'assistance IA"
        },
        "hints": {
          "creatingLearningObjectives": "L'IA crée des objectifs d'apprentissage",
          "creatingTextBasis": "L'IA crée le texte de base",
          "error": "Une erreur est survenue. Malheureusement, nous n'avons pas pu créer de suggestions pour vous.",
          "learningObjectives": "Des objectifs d'apprentissage concrets aident à définir le contexte des tâches plus précisément et à obtenir des suggestions plus appropriées.",
          "progressMessage": "Les tâches sont en cours de création",
          "prompt": "Astuce : Plus vous êtes spécifique, plus les tâches proposées seront concrètes.",
          "textBasis": "Le texte de base sert à affiner le focus de la fiche d'exercices."
        },
        "knowledge": {
          "subtitle": "Tu peux éventuellement ajouter une source à partir de laquelle l'IA extraira les connaissances de base pour la fiche d'exercices."
        },
        "labels": {
          "gradeLevel": "Sélectionner le niveau d'âge",
          "languageLevel": "Sélectionner le niveau de langue (GER)",
          "learningObjectiveHeading": "Objectif d'apprentissage pour cette fiche d'exercices",
          "learningObjectives": "Objectifs d'apprentissage (facultatif)",
          "schoolType": "Sélectionner le type d'école",
          "subjectType": "Sélectionner la matière",
          "textBasis": "Sur quels contenus la fiche d'exercices doit-elle se concentrer ?",
          "topic": "Sujet ou question",
          "topicHeading": "Thème ou question pour cette fiche d'exercices",
          "worksheetLanguage": "Sélectionner la langue"
        },
        "placeholders": {
          "learningObjectiveHeading": "Quelles compétences doivent être développées ? (p. ex. analyse et évaluation des conditions de départ de la République de Weimar).",
          "learningObjectives": "Saisir les objectifs d'apprentissage...",
          "prompt": "Indiquez les contenus essentiels auxquels les tâches doivent se référer. Par exemple : Le début de la République de Weimar.",
          "textBasis": "Saisir le texte de base...",
          "topicHeading": "Quels thèmes principaux la fiche d'exercices doit-elle traiter ? (p. ex. « Le début de la République de Weimar »)"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Générer une tâche de texte avec l'IA"
        },
        "labels": {
          "prompt": "Exigences"
        },
        "placeholders": {
          "prompt": "Décrivez le focus de la tâche et indiquez éventuellement une question directrice ou un objectif d'apprentissage."
        },
        "description": "Que souhaitez-vous créer ?"
      },
      "aiGeneration": {
        "createWithAi": "Créer avec l'IA",
        "dropdownLabel": "Options de génération IA",
        "pending": "L'IA crée le contenu...",
        "menu": {
          "newVariant": "Varier le contenu",
          "harder": "Tâche plus difficile",
          "easier": "Tâche plus facile",
          "addHelp": "Ajouter des indications",
          "simpleLanguage": "Langage simple",
          "custom": "Demande personnalisée"
        },
        "prompts": {
          "newBlock": "Crée un bloc {blockType} adapté comme prochaine étape pertinente de cette fiche d'activité.",
          "newVariant": "Crée une variante de ce bloc : modifie le contexte, les nombres ou la formulation de sorte que la tâche ne puisse pas être résolue en se souvenant de l'original. L'objectif d'apprentissage et le niveau de difficulté restent inchangés.",
          "harder": "Rends ce bloc plus exigeant en demandant davantage de réflexion, et non davantage de travail.",
          "easier": "Rends ce bloc plus facile : simplifie la langue et la structure et supprime les informations inutiles. L'objectif d'apprentissage et les termes techniques restent inchangés ; explique les termes techniques au lieu de les remplacer.",
          "addHelp": "Ajoute des indications, des étapes intermédiaires ou des exemples utiles sans donner la solution.",
          "simpleLanguage": "Reformule ce bloc en langage simple. Conserve les termes techniques de l’objectif pédagogique et du bloc, et explique-les si nécessaire.",
          "guidance": {
            "fillInTheBlank": "Pour le texte à trous : remplis la description et le texte à trous ; varie les trous selon la demande."
          }
        }
      },
      "aiContext": {
        "title": "Focus IA pour cette fiche d'exercices",
        "button": "Paramètres IA",
        "description": "Ici, vous pouvez indiquer pour qui vous souhaitez créer la fiche d'exercices. Ces informations aident l'IA à vous proposer des tâches appropriées. Dans les différents blocs de tâches, vous pouvez demander à l'IA de vous suggérer des contenus.",
        "sections": {
          "schoolDetails": {
            "title": "Données clés scolaires"
          },
          "backgroundKnowledge": {
            "title": "Connaissances de base"
          }
        },
        "labels": {
          "subjectTypes": "Matière scolaire",
          "schoolTypes": "Type d'école",
          "gradeLevels": "Niveau de classe",
          "locale": "Langue",
          "addBackgroundKnowledge": "Ajouter des connaissances de base",
          "backgroundKnowledge": "Connaissances de base pour l'IA"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Ajoutez des connaissances de différentes sources, par exemple via le téléchargement de fichiers ainsi que depuis des sites web, des vidéos YouTube, des fichiers audio ou des vidéos."
        },
        "actions": {
          "removeSource": "Supprimer la source"
        },
        "hints": {
          "hasSources": "Sources disponibles"
        },
        "sourceKinds": {
          "text": "Texte",
          "file": "Fichier",
          "pdf": "PDF",
          "image": "Image",
          "website": "Site web",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Vidéo"
        },
        "flash": {
          "saveFailed": "Les paramètres IA n'ont pas pu être enregistrés"
        },
        "sourcePicker": {
          "title": "Ajouter des connaissances de base",
          "subtitle": "Choisissez une source et l'IA en extrait le texte comme connaissances de base pour la fiche d'exercices."
        },
        "recent": {
          "empty": "Aucune source pour le moment. Ajoutez d'abord des connaissances contextuelles.",
          "error": "Les dernières sources utilisées n'ont pas pu être chargées."
        },
        "placeholders": {
          "backgroundKnowledge": "Complétez les informations et mettez en avant les aspects de contenu qui vous tiennent particulièrement à cœur..."
        }
      },
      "blockTypes": {
        "Divider": "Ligne de séparation",
        "File": "Fichier",
        "FillInTheBlankText": "Texte à trous",
        "H5p": "H5P",
        "Hint": "Astuce",
        "Image": "Image",
        "MultipleChoice": "Choix multiple",
        "SingleChoice": "Choix unique",
        "Spacer": "Espacement",
        "PageBreak": "Saut de page",
        "StaticText": "Texte",
        "Text": "Réponse texte",
        "Upload": "Soumission de fichier",
        "Video": "Vidéo",
        "ToTeachExercise": "Exercice to teach"
      },
      "blockTypesV2": {
        "Upload": "Soumission de fichier",
        "ToTeachExercise": "Exercice to teach"
      },
      "inserterHints": {
        "toTeachExercise": "Nouveau : Utilisez vos contenus de to teach dans vos fiches d'exercices fobizz.",
        "pageBreak": "Nouveau : Concentrez la vue avec des sauts de page."
      },
      "navigation": {
        "headline": "Votre progression",
        "previousPage": "Retour",
        "nextPage": "Page suivante"
      },
      "buttons": {
        "addOption": "Ajouter une option",
        "submit": "Soumettre",
        "confirmDelete": "Oui, supprimer",
        "duplicate": "Dupliquer",
        "generate": "Générer",
        "deleteResponse": "Supprimer la soumission",
        "moveDown": "Déplacer vers le bas",
        "moveUp": "Déplacer vers le haut",
        "remove": "Supprimer",
        "removeOption": "Supprimer l'option"
      },
      "elements": "Éléments",
      "addNewBlock": "Ajouter un nouveau bloc",
      "multimedia": "Multimédia",
      "layout": "Mise en page",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Supprimer le feedback",
              "message": {
                "success": "Feedback supprimé"
              }
            },
            "submit": {
              "label": "Enregistrer le feedback",
              "message": {
                "error": "Le feedback n'a pas pu être enregistré",
                "success": "Feedback enregistré"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Écrire un message texte"
            }
          },
          "headline": "Donner un feedback individuel"
        },
        "public": {
          "headline": "Feedback de {name} sur votre soumission"
        },
        "shareLinkBox": "Partager le lien de soumission avec feedback",
        "status": {
          "hasFeedback": "Feedback donné"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "Ceci est un exemple de texte à trous avec un {'{'} trou {'}'}. Plusieurs réponses peuvent être données {'{'} nombreuses/plusieurs/différentes {'}'}. Dans ce cas, 'trou' serait la réponse correcte dans la première phrase. Dans la deuxième phrase, 'nombreuses', 'plusieurs' et 'différentes' seraient correctes.",
        "description": "Votre texte de description avec des instructions pour le traitement (pas le texte à trous). Vous pouvez également proposer des suggestions de solutions pour l'association, par exemple : 'Remplissez le texte à trous avec les termes suivants : <i><mark>Mot 1</mark></i>, <i><mark>Mot 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Texte de description",
        "descriptionHint": "Utilisez le texte de description pour les instructions de traitement. Vous pouvez également proposer des suggestions de solutions pour l'association. Par exemple {italic}",
        "descriptionHintItalic": "\"Remplissez le texte à trous avec les termes suivants : Allemagne, État fédéral, République,...\"",
        "clozeLabel": "Texte à trous",
        "clozeHint": "\"Exemple de texte à trous avec un <strong>{'{'} trou {'}'}</strong>. Plusieurs <strong>{'{'} nombreuses/plusieurs {'}'}</strong> réponses peuvent être définies.\" Dans ce cas, 'trou' serait la réponse correcte et dans la deuxième phrase, 'nombreuses' et 'plusieurs' seraient correctes.",
        "insertGap": "Insérer un trou"
      },
      "flash": {
        "addOptionSuccess": "Option ajoutée",
        "createBlockSuccess": "Bloc ajouté",
        "createSolutionSuccess": "Solution ajoutée",
        "deleteBlockSuccess": "Bloc supprimé",
        "duplicateBlockSuccess": "Bloc dupliqué",
        "deleteOptionSuccess": "Option supprimée",
        "deleteSolutionSuccess": "Solution supprimée",
        "moveBlockSuccess": "Bloc déplacé",
        "updateBlockSuccess": "Bloc mis à jour",
        "updateClozeTestSuccess": "Texte à trous mis à jour",
        "updateOptionSuccess": "Option mise à jour",
        "updateSolutionSuccess": "Solution mise à jour",
        "updateWorksheetSuccess": "Fiche d'exercices mise à jour",
        "updateWorksheetError": "La fiche d'exercices n'a pas pu être mise à jour"
      },
      "headings": {
        "saveShareLink": "Notez ce lien pour retrouver facilement vos résultats plus tard."
      },
      "hints": {
        "Divider": "Utilisez la ligne de séparation pour structurer visuellement la fiche d'exercices et séparer une section de la suivante.",
        "File": "Insérez ici du matériel pédagogique (par exemple, un fichier texte, une image ou un PDF) que vos élèves doivent télécharger ou consulter. Conseil : utilisez le bloc de tâches de téléchargement pour récupérer directement le fichier traité par vos élèves.",
        "FillInTheBlankText": "Écrivez un texte à trous ou une question avec un seul trou de réponse. Utilisez les symboles {'{'} et {'}'} pour marquer un trou et entourer les mots de solution possibles. Si plus d'un mot peut être correct, séparez les mots de solution par un /. Une phrase d'exemple pourrait être : \"Les élèves doivent {'{'}un/le{'}'} trou remplir.\" Ici, 'un' et 'le' sont des réponses correctes. Toutes les réponses sont évaluées directement.",
        "H5p": "Intégrez des contenus interactifs H5P dans votre fiche d'exercices. Téléchargez un fichier .h5p pour créer des exercices interactifs, des quiz et des jeux éducatifs.",
        "Hint": "Donnez à vos élèves des conseils supplémentaires avec ce texte d'indication visuellement mis en évidence.",
        "Image": "Ajoutez une image à partir de la recherche d'images ou téléchargez votre propre image pour enrichir votre fiche d'exercices avec du contenu visuel.",
        "MultipleChoice": "Posez une question et entrez les options de réponse. Marquez les réponses correctes en cliquant sur le cercle devant. L'évaluation vous montre directement les tâches pour lesquelles vos élèves ont le plus de confiance – ou le plus besoin de répétition.",
        "SingleChoice": "Posez une question et entrez les options de réponse. Marquez la réponse correcte en cliquant sur le cercle devant. L'évaluation vous montre directement les tâches pour lesquelles vos élèves ont le plus de confiance – ou le plus besoin de répétition.",
        "Spacer": "Ajoutez des espaces à votre fiche d'exercices pour rendre le contenu plus clair.",
        "PageBreak": "Utilisez le saut de page pour diviser la fiche d'exercices en plusieurs pages entre lesquelles vous pouvez naviguer.",
        "StaticText": "Utilisez l'élément texte pour donner à vos élèves des explications, des indications et des informations supplémentaires pour traiter les tâches. Remarque : ici, vos élèves ne peuvent pas remplir numériquement, contrairement aux blocs de questions.",
        "Text": "Rédigez une tâche pour laquelle vos élèves peuvent soumettre une réponse dans un champ de texte numérique.",
        "Upload": "Formulez une tâche pour laquelle vos élèves doivent télécharger un fichier (par exemple, un fichier texte, une image ou un PDF). Vous pouvez ensuite évaluer tous les fichiers soumis en un seul endroit.",
        "ToTeachExercise": "Recherchez des exercices interactifs de to teach et intégrez-les directement dans votre fiche d'exercices.",
        "Video": "Intégrez des vidéos YouTube ou Vimeo via un lien (par exemple : https://vimeo.com/469669139).",
        "answered": "répondu",
        "dragNDrop": "Conseil : vous pouvez télécharger un fichier par glisser-déposer",
        "dropFileHere": "Glissez le fichier ici ou ",
        "dropH5pFileHere": "Glissez le fichier H5P ici ou",
        "uploadH5pFilePrompt": "Glissez le fichier H5P ici ou sélectionnez un fichier",
        "elements": "Intégrez des explications et des contenus pour vos élèves et structurez votre fiche d'exercices.",
        "h5pContentStatus": "Statut : {status}",
        "h5pFileRequirement": "Seuls les fichiers .h5p sont autorisés",
        "h5pProcessing": "Le contenu H5P est en cours de traitement, veuillez patienter...",
        "h5pProcessingFailed": "Le traitement H5P a échoué. Veuillez réessayer.",
        "h5pProcessingStalled": "Le traitement de ce contenu H5P prend un temps inhabituellement long. Veuillez réessayer plus tard ou contacter le support.",
        "h5pReloadHint": "Le contenu ne s'affiche pas ? Recharger la page",
        "h5pFileUploadSuccess": "Fichier H5P téléchargé avec succès.",
        "h5pPreviewHint": "Dans l'aperçu, vous pouvez essayer le module.",
        "toTeachExerciseImportSuccess": "Exercice to teach importé avec succès.",
        "maxOptionsReached": "Un maximum de {max} options peuvent être ajoutées.",
        "name": "Entrez ici votre pseudonyme ou vos initiales.",
        "noDescriptionOrCloze": "Aucune description et aucun texte à trous enregistrés",
        "emptyBlock": "<strong>Ce bloc est vide.</strong> Il n'apparaît ni dans l'aperçu ni dans la vue pour les élèves.",
        "noDescriptionOrOptions": "Aucune description ou option enregistrée",
        "fileUploadSuccess": "Fichier téléchargé avec succès.",
        "noFile": "Aucun fichier téléchargé",
        "noH5pContent": "Aucun contenu H5P téléchargé",
        "h5pNotPrintable": "Ce contenu interactif ne peut pas être imprimé.",
        "noHint": "Aucun conseil saisi",
        "noImage": "Aucune image téléchargée",
        "noInput": "Aucune indication",
        "selectFile": "Sélectionner un fichier",
        "noSolution": "Aucune solution enregistrée",
        "noText": "Aucun texte saisi",
        "noVideo": "Aucune vidéo intégrée",
        "processingH5pFile": "Le fichier H5P est en cours de traitement...",
        "questions": "Créez des tâches avec des champs que vos élèves peuvent remplir.",
        "submitSuccessful": "Merci ! Vous avez soumis votre fiche d'exercices avec succès.",
        "searchToTeachExercises": "Recherche d'exercices to teach...",
        "processingToTeachExercise": "L'exercice to teach est importé et traité...",
        "noToTeachExercisesFound": "Aucun exercice trouvé",
        "noToTeachExercise": "Aucun exercice to teach sélectionné",
        "toTeachSsoNotLinked": "Votre compte n'est pas encore lié à to teach. Connectez votre compte pour utiliser vos contenus to teach sur fobizz. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Accéder à to teach</a>",
        "videoError": "L'URL saisie est invalide. Entrez une adresse correcte ou supprimez votre saisie.",
        "videoExample": "Exemple : https://vimeo.com/469669139",
        "uploadFilePrompt": "Glissez le fichier ici ou sélectionnez un fichier"
      },
      "labels": {
        "confirmDeleteBlock": "Supprimer le bloc ?",
        "confirmDeleteBlockText": "Attention : si vous supprimez ce bloc, toutes les soumissions éventuellement associées seront également supprimées.",
        "confirmDeleteResponse": "Supprimer vraiment la soumission ?",
        "confirmDeleteResponseText": "Voulez-vous vraiment supprimer la soumission ?",
        "confirmSubmitIncompleteResponse": "Toutes les tâches ne sont pas encore terminées. Voulez-vous quand même soumettre la fiche d'exercices ?",
        "confirmSubmitResponse": "Voulez-vous soumettre la fiche d'exercices maintenant ?",
        "confirmSubmitResponseTitle": "Soumettre la fiche d'exercices ?",
        "confirmSubmitKeepEditing": "Continuer à modifier",
        "confirmSubmitAnyway": "Oui, soumettre",
        "draft": "Brouillon | Brouillons",
        "response": "Soumission | Soumissions",
        "responseStatus": {
          "draft": "En cours",
          "submitted": "Terminé"
        },
        "respondingAs": "Vous répondez à cette fiche d'exercices en tant que {pseudonym}",
        "responsesTab": "Brouillons et soumissions",
        "worksheet": "Fiche d'exercices"
      },
      "links": {
        "shareResponse": "Copier le lien d'accès",
        "showResponseSolutionToggle": "Afficher les solutions modèles",
        "taskNo": "{ index }. Tâche"
      },
      "placeholders": {
        "FillInTheBlankText": "Entrer le texte à trous ici",
        "answerInput": "Entrer la réponse ici",
        "clickToEdit": "Cliquer pour modifier",
        "description": "Entrer la description ici",
        "hint": "Entrer le conseil ici",
        "imageCaption": "Entrer la légende ici",
        "optionInput": "Entrer l'option ici",
        "videoCaption": "Entrer la légende vidéo ici",
        "videoUrl": "Entrer l'URL de la vidéo"
      },
      "promptAttributes": {
        "derivedLanguageSkillLevel": {
          "1": "dans un langage très simple et des formulations faciles à comprendre pour les enfants de 5 à 7 ans",
          "2": "dans un langage simple et des formulations faciles à comprendre pour les enfants de 7 à 10 ans",
          "3": "dans un langage clair et compréhensible pour les enfants de 10 à 13 ans",
          "4": "dans un langage compréhensible et des formulations claires pour les adolescents de 13 à 16 ans",
          "5": "dans un langage approprié et avec des termes et formulations spécifiques pour les jeunes adultes de 17 ans ou plus"
        },
        "regeneration": {
          "prompt": "\n\nIMPORTANT : Crée de nouvelles propositions nettement différentes. Ne répète aucune des propositions précédentes suivantes et ne les reformule pas légèrement.{strategyInstruction}\nPropositions précédentes :\n{previousProposals}",
          "strategyInstruction": "\nUtilise cette fois-ci cette approche alternative : {strategy}",
          "strategies": {
            "everydayContext": "Utilise un contexte quotidien avec des exemples concrets.",
            "playfulFormat": "Utilise une formulation ludique ou énigmatique avec une autre structure de phrase.",
            "analyticalPerspective": "Utilise une perspective factuelle-analytique avec d'autres points de contenu.",
            "creativeScenario": "Utilise une histoire créative ou un nouveau scénario comme point de départ.",
            "compareCauseEffect": "Utilise un focus de comparaison ou de cause-effet au lieu de l'approche précédente."
          }
        },
        "systemPrompt": "Tu es un·e enseignant·e de {subjectType} dans une {schoolType} et tu connais très bien les contenus du programme pour ce groupe cible. Ton résultat doit être formulé de manière appropriée pour les élèves du niveau {gradeLevel} et {derivedLanguageSkillLevel}.\n Tu DOIS répondre uniquement en JSON. Tu DOIS utiliser la définition de schéma fournie et les exemples. Ne retourne aucun champ ou texte supplémentaire.",
        "userPrompt": {
          "fill_in_the_blank_text": "Réfère-toi à tous les textes de base marqués par des guillemets triples. Texte de base : \"\"\"{textBasis}\"\"\". Crée 3 versions d'un court texte à trous avec 5 trous chacun, en reformulant les contenus du texte de base. Chaque trou doit être présenté par des accolades et inclure la solution. Le texte doit être rendu au format JSON et suivre cet exemple de format : ",
          "learning_objectives": "Tu es un expert en objectifs pédagogiques et en formulation de tâches dans le domaine {subjectType}, spécialisé dans la taxonomie de Bloom. Ta mission : Formuler des objectifs d'apprentissage pour une unité de cours pour le niveau {gradeLevel} sur le sujet '{prompt}'. Différencie les objectifs d'apprentissage pour couvrir les niveaux 1-2, 3-4 et 5 de la taxonomie et formule 2 objectifs d'apprentissage par niveau. Donne des phrases principales simples.",
          "single_choice": "Réfère-toi à tous les textes de base marqués par des guillemets triples. Texte de base : \"\"\"{textBasis}\"\"\". Écris un quiz avec 3 questions et 3 réponses, y compris la solution. Une seule réponse doit être correcte. Formule les tâches toujours en tutoiement. Le texte doit être rendu au format JSON et suivre cet exemple de format : ",
          "text_assignment": "Réfère-toi à tous les textes de base marqués par des guillemets triples. Crée 3 tâches textuelles détaillées se rapportant au texte de base, chacune avec une solution modèle d'environ {\n          count\n        } mots. Les tâches correspondent au domaine d'exigence {\n          name\n        } avec la définition : '{\n          description\n        }'. Texte de base : \"\"\"{textBasis}\"\"\".\n        Formule les tâches toujours en tutoiement. Ne pose pas de questions en W avec les mots interrogatifs Qui ?, Quoi ?, Quand ?, Où ?, Pourquoi ?, Comment ?, Dans quel but ?, mais choisis pour chaque tâche un des opérateurs suivants et utilise-le à l'impératif : {operators}. Le texte doit être rendu au format JSON et suivre cet exemple de format : ",
          "text_basis": "Écris un texte informatif comme base pour une fiche d'exercices, qui présente et explique de manière claire les contenus pertinents pour le programme allemand dans le domaine {subjectType}. Le texte doit uniquement contenir des informations et contribuer à atteindre les objectifs d'apprentissage suivants : '{learningObjectives}'. Le sujet du texte est '{prompt}'. Ne donne que les contenus demandés et évite les commentaires introductifs et conclusifs pour encadrer la réponse. Le texte doit être composé d'un seul paragraphe de 100 à 500 mots et ne doit pas contenir de caractères spéciaux, de caractères de contrôle ou de sauts de ligne. Le texte doit être rendu au format JSON et suivre cet exemple de structure de données : "
        }
      },
      "questions": "Interroger",
      "solution": {
        "actions": {
          "add": "Ajouter une solution modèle",
          "delete": "Supprimer la solution modèle",
          "showResponseSolution": "Afficher toutes les solutions après soumission"
        },
        "hints": {
          "showResponseSolution": "Tes élèves voient les solutions modèles enregistrées directement après la soumission."
        },
        "title": "Solution modèle",
        "types": {
          "text": {
            "placeholder": "Entrer la solution modèle ici..."
          }
        }
      },
      "words": {
        "of": "de"
      }
    }
  }
}
